(function() {
    'use strict';

    angular
        .module('papp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('Notification', {
            abstract: true,
            parent: 'app'
        });
    }
})();
